export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
export const NEW_MESSAGE = 'Este mes... ¡Equipos escapistas!'

export const WIN_MESSAGES = ['¡Bien hecho!', '¡Correcto!']
export const GAME_COPIED_MESSAGE = 'Resultado copiado al portapapeles'
export const ABOUT_GAME_MESSAGE = 'Sobre este juego'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'No hay suficientes letras'
export const WORD_NOT_FOUND_MESSAGE = 'Escape o palabra no encontrada'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `La solución era ${solution}`
export const ENTER_TEXT = 'Enviar'
export const DELETE_TEXT = 'Borrar'
export const STATISTICS_TITLE = 'Resultado'
export const GUESS_DISTRIBUTION_TEXT = 'Distribución'
export const NEW_WORD_TEXT = 'Siguiente palabra en '
export const SHARE_TEXT = 'Compartir'
export const TOTAL_TRIES_TEXT = 'Jugados'
export const SUCCESS_RATE_TEXT = 'Victorias'
export const CURRENT_STREAK_TEXT = 'Current streak'
export const BEST_STREAK_TEXT = 'Best streak'
